import React, { Component } from 'react';

class ViewAttachedExcelDocumentTable extends Component {
  render() {
    return (
      <div className="table-responsive tableHeightExcel">
        <table className="table table-striped">
          <thead>
            <tr className="table-header-row text-center">
              {this.props.cols.map((c) => (
                <th key={c.key}>{c.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.props.data.map((r, i) => (
              <tr key={i}>
                {this.props.cols.map((c) => (
                  <td key={c.key}>{r[c.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ViewAttachedExcelDocumentTable;
